import { FC, useState } from 'react';
import EditorVideo from 'lowcode/components/EditorVideo';
import EditorImg from 'lowcode/components/EditorImg';
import EcoSpace from 'eco-design/base/eco-space';
import EcoTitle from 'eco-design/base/eco-title';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import styles from './index.module.scss';
import IconArrow from './IconArrow';
import { useLang } from '@/i18n';

const TheComp: FC = () => {
    const { t } = useLang('dp3.page_v2.AccordionVideo');
    const [hoverIndexA, setHoverIndexA] = useState<number>(1);
    const [hoverIndexB, setHoverIndexB] = useState<number>(1);

    const handleHoverA = (index: number) => {
        setHoverIndexA(index);
        if (index === 3) {
            const elem: any = document.querySelector('#AccordionVideo .comp-video-box video');
            if (elem && elem.play) elem.play();
        }
    };

    const handleHoverB = (index: number) => {
        setHoverIndexB(index);
    };

    const accordionItems = [
        {
            id: 1,
            type: 'simple',
            title: t('item1_title'),
            image: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718886436372/a1.jpg',
            desc: t('item1_desc')
        },
        {
            id: 2,
            type: 'simple', 
            title: t('item2_title'),
            image: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719217603410/a33.jpg',
            desc: t('item2_desc')
        },
        {
            id: 3,
            type: 'complex',
            title: t('item3_title'),
            video: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/video/1718709891957/v1.mp4',
            images: [
                'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718875833780/app1.jpg',
                'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718875860625/app2.jpg'
            ],
            labels: [
                { title: t('item3_label1_title'), desc: t('item3_label1_desc') },
                { title: t('item3_label2_title'), desc: t('item3_label2_desc') },
                { title: t('item3_label3_title'), desc: t('item3_label3_desc') }
            ]
        }
    ];

    return (
        <div className={styles.comp} id="AccordionVideo">
            <EcoSpace />
            <div className="comp-module">
                <div className="comp-module-l">
                    {accordionItems.map((item) => (
                        <div
                            key={item.id}
                            className={`${item.type === 'complex' ? 'lista-box lista-box-1' : 'listb-box'}${hoverIndexA === item.id ? ' comp-hover' : ''}`}
                            onClick={() => handleHoverA(item.id)}
                        >
                            <div className={`${item.type === 'complex' ? 'lista' : 'listb'}-title comp-sub-title`}>
                                {item.title}
                                <IconArrow />
                            </div>

                            <div className="comp-video-box">
                                {item.type === 'complex' ? (
                                    <>
                                        <EditorVideo pc={item.video} autoPlay loop />
                                        {(item?.images || []).map((img, idx) => (
                                            <EditorImg 
                                                key={idx}
                                                pc={img}
                                                className={`comp-sub-a comp-sub-a-${idx + 2}`}
                                            />
                                        ))}
                                    </>
                                ) : (
                                    <EditorImg pc={item.image} />
                                )}
                            </div>

                            {item.type === 'complex' ? (
                                <div className="lista-desc-box">
                                    {(item?.labels || []).map((label, idx) => (
                                        <div
                                            key={idx}
                                            className={`listc-box listc-box-${idx + 1}${hoverIndexB === idx + 1 ? ' hover' : ''}`}
                                            onClick={(e) => { e.stopPropagation(); handleHoverB(idx + 1); }}
                                        >
                                            <div className="listc-title">{label.title}</div>
                                            <div className="listc-desc comp-sub-desc">{label.desc}</div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="listb-desc comp-sub-desc">{item.desc}</div>
                            )}
                        </div>
                    ))}
                </div>
                <div className="comp-module-r"></div>
            </div>
            <EcoSpace />
        </div>
    );
};

export default TheComp;
